import GetIssuuEmbedDocumentRequestModelBase from '../_generated/modelBases/get-issuu-embed-document-request-model-base';

export default class GetIssuuEmbedDocumentRequestModel extends GetIssuuEmbedDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
